import {
  fetchGetOpenBankingProviders,
  GetOpenBankingProvidersResponse,
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { TOnlineBank } from '../../components/TradingHistory/OpenBanking/OpenBanking.types';

export function useGetOpenBankingProviders({
  stateKey,
  token,
}: {
  stateKey?: string;
  token?: string;
}) {
  const {
    data: openBankingProviders,
    isLoading,
    isError,
  } = useQuery<GetOpenBankingProvidersResponse>({
    queryKey: ['getOpenBankingProviders', stateKey, token],
    queryFn: () =>
      fetchGetOpenBankingProviders({ stateKey: stateKey!, token: token! }),
    enabled: Boolean(stateKey) && Boolean(token),
  });

  const getTrueLayerBankList = (): TOnlineBank[] => {
    if (!openBankingProviders?.data?.open_banking) return [];

    const openBanking = openBankingProviders?.data.open_banking as {
      truelayer_banks?: TOnlineBank[];
      finapi_banks?: TOnlineBank[];
    };

    const truelayerBanks: TOnlineBank[] = (
      openBanking.truelayer_banks || []
    ).map((bank) => ({
      ...bank,
      provider: 'truelayer' as const,
    }));

    return [...truelayerBanks];
  };

  return {
    bankList: getTrueLayerBankList(),
    isLoading,
    isError,
  };
}
